import React from 'react';
import HashLoader from "react-spinners/HashLoader";


const LoadingComponent = (props) => {
  const {backgroundColor= true,  children = null } = props;
  return (
    <>
      <div style={{
        display:  "flex",
        backgroundColor: backgroundColor ? "rgba(255, 255, 255, 0.35)" : "",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        position: "absolute",
        zIndex: "2",
      }}
      className={props.className}>
        <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
          height: "100%",
        }}
        >
          <HashLoader size={80} color={"#0063c3"} />
        </div>
      </div>
    </>
  )
}

export default LoadingComponent;
